"use strict";
import { BigNumber } from "ethers/lib/ethers";
import {
  fetchTopazApiQuote
} from "features/routing/api/topazRoutingApi";
import { TransactionStepType } from "features/transactions/steps/types";
import {
  validateTransactionRequest
} from "features/transactions/swap/utils/trade";
function toTopazApiPermit(typedData) {
  const values = typedData.values;
  if (!values?.details || !values.spender || values.sigDeadline === void 0) {
    return void 0;
  }
  return {
    details: {
      token: values.details.token,
      amount: BigNumber.from(values.details.amount).toString(),
      expiration: Number(values.details.expiration),
      nonce: Number(values.details.nonce)
    },
    spender: values.spender,
    sigDeadline: Number(values.sigDeadline)
  };
}
function maxAcceptedDropBps(slippageBips) {
  return BigInt(Math.max(0, Math.min(slippageBips ?? 50, 100)));
}
export function createTopazApiSwapTransactionAsyncStep({
  trade,
  permitTypedData,
  chainId,
  from
}) {
  const request = trade.topazApiRequest;
  const acceptedQuote = trade.topazApiResponse?.quote;
  if (!trade.isTopazApi || !request?.recipient) {
    return void 0;
  }
  return {
    type: TransactionStepType.SwapTransactionAsync,
    getTxRequest: async (signature) => {
      const permit = toTopazApiPermit(permitTypedData);
      if (!permit) {
        return void 0;
      }
      const response = await fetchTopazApiQuote(request, { ...permit, signature });
      if (acceptedQuote) {
        const accepted = BigInt(acceptedQuote);
        const fresh = BigInt(response.quote);
        const dropBps = maxAcceptedDropBps(request.slippageBips);
        if (fresh * 10000n < accepted * (10000n - dropBps)) {
          throw new Error("Price moved while confirming. Please review the updated quote and try again.");
        }
      }
      const methodParameters = response.methodParameters;
      if (!methodParameters) {
        return void 0;
      }
      return validateTransactionRequest({
        to: methodParameters.to,
        data: methodParameters.calldata,
        value: methodParameters.value,
        from: from ?? request.recipient,
        chainId
      });
    }
  };
}
